import {base} from "./base";
import router from "@/router";

async function register(user) {
  return base.post("users/register", user, false, false);
}

async function login(email, password) {
  return base.post(
    "accounts/login",
    {email, password},
    false,
    false
  );
}

async function loginWithToken(token) {
  return base.post(`login-with-token?token=${token}`);
}

function logout() {
  localStorage.removeItem("user");
  router.push("/login");
}

async function recoveryPassword(email) {
  return base.post(`accounts/forgot-password`, {email}, false, false);
}

async function resetPassword(data) {
  return base.put(`accounts/forgot-password`, data, false, false);
}

async function me() {
  return base.get(`users/me`, {}, true, false);
}

export const auth = {
  login,
  loginWithToken,
  logout,
  register,
  recoveryPassword,
  resetPassword,
  me,
};
